import IconFont from "@/components/IconFont";
import { motion } from "framer-motion";
import { useTranslation } from "next-i18next";

interface Props {
	onClick?: () => void;
}
export default function ContactUsFinished(props: Props) {
	const { t } = useTranslation("activities");
	return (
		<div className="px-4 pb-14 pt-8">
			<p className="text-center text-sm font-bold text-white">{t("sorry-the-event-is-over-see-you-next-time")}</p>
			<motion.a
				id="contact-us-finished"
				className="mt-3.5 flex h-12 w-full items-center justify-center rounded-3xl border-[2px] border-white"
				onClick={props.onClick}
				whileTap={{ scale: 0.95 }}
			>
				<IconFont type="xingzhuang" style={{ fontSize: "20px", marginRight: "2px" }} />
				<span className="pl-0.5 text-sm font-bold text-white -mt-0.5">{t("contactSupport")}</span>
			</motion.a>
		</div>
	);
}
